module.exports = __webpack_public_path__ + "img/title_bg.5983d544.png";